import { useState, useEffect } from 'react';
import { FaThLarge } from 'react-icons/fa';
import { isAuth } from '../../helper/auth';
import axios from 'axios';

export default function AdminNavbar({ showSidebar, setShowSidebar }) {
    const user = isAuth()
    const [userData, setUserData] = useState(null);

    useEffect(() => {
        const getUserData = async () => {
            try {
                const response = await axios.get(`/api/user`, { withCredentials: true });
                setUserData(response.data);
            } catch (error) {
                console.error('Error fetching user data:', error);
            }
        };
        getUserData();
    }, []);

    const displayName = userData?.nama || user?.nama || 'Staff';

    return (
        <>
            <nav className="md:bg-white md:backdrop-blur-sm bg-zafu-green md:border-b md:border-gray-200 md:ml-64 py-2 md:py-4 px-4 sticky top-0 z-[45] h-12 md:h-[4.75rem] flex items-center">
                <div className="container max-w-full mx-auto flex items-center justify-between md:pr-4 w-full">
                    <div className="md:block hidden">
                        <button
                            onClick={() => setShowSidebar('-left-64')}
                            className="text-zafu-green hover:bg-zafu-cream-dark py-2 px-3 bg-white rounded-full shadow-zafu"
                        >
                            <FaThLarge />
                        </button>
                    </div>
                    <div className="md:hidden flex items-center gap-2">
                        <div className="w-8 h-8 rounded-full bg-zafu-cream text-zafu-green font-display font-bold flex items-center justify-center">
                            Z
                        </div>
                        <span className="text-white text-base font-semibold tracking-wide">ZAFU RESIDENCE</span>
                    </div>
                    <div className="hidden md:flex justify-end items-center w-full">
                        <span className="text-sm text-zafu-muted mr-2">Staff</span>
                        <span className="font-medium text-zafu-ink">{displayName}</span>
                    </div>
                </div>
            </nav>
        </>
    );
}
